import { render } from "./MyShopSyncs.vue?vue&type=template&id=0f9c75ff"
import script from "./MyShopSyncs.vue?vue&type=script&lang=js"
export * from "./MyShopSyncs.vue?vue&type=script&lang=js"
script.render = render

export default script